import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { attrRicerca, Cella, fmtData, useUltimaRichiesta } from "@/lib/listaColonne";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { ContatoreContatto, useCrmMe, useAziendaCrm, CampoAzienda, TornaIndietro, TitoloCrm, fmtTelefono } from "./crmComuni";

export default function CrmContatti() {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [dati, setDati] = useState({ items: [], total: 0 });
  const ultima = useUltimaRichiesta();
  const crmMe = useCrmMe();
  const [cid, setCid, aziende] = useAziendaCrm(crmMe);
  const carica = useCallback(() => {
    if (!cid) return;
    const valida = ultima();
    api.get(`/crm/contatti?company_id=${cid}&page_size=200${q.trim() ? `&q=${encodeURIComponent(q.trim())}` : ""}`)
      .then((r) => { if (valida()) setDati(r.data); }).catch(() => {});
  }, [q, ultima, cid]);
  useEffect(() => { const t = setTimeout(carica, 250); return () => clearTimeout(t); }, [carica]);
  return (
    <div className="space-y-6" data-testid="crm-contatti-page">
      <TornaIndietro to="/crm" testo="Torna al CRM" testid="crm-contatti-indietro" />
      <div className="flex items-end gap-x-3 gap-y-2 flex-wrap">
        <TitoloCrm sotto="Contatti" />
        <span className="text-sm text-slate-500" data-testid="crm-contatti-conteggio">{dati.total} contatti</span>
        <CampoAzienda aziende={aziende} cid={cid} onScegli={setCid} />
      </div>
      <Card className="p-4 space-y-3">
        <Input {...attrRicerca("crm-contatti")} placeholder="Cerca nome, telefono o email" value={q} onChange={(e) => setQ(e.target.value)}
          className="w-80" data-testid="crm-contatti-ricerca" />
        <table className="w-full text-sm lista-uniforme" data-testid="crm-contatti-tabella">
          <thead className="bg-slate-50 border-b">
            <tr className="text-left text-[12px] text-slate-600 uppercase tracking-wide">
              <th className="px-3 py-2">Nome</th><th className="px-3 py-2">Telefoni</th><th className="px-3 py-2">Email</th>
              <th className="px-3 py-2">Opportunità</th><th className="px-3 py-2">Ultima attività</th>
            </tr>
          </thead>
          <tbody>
            {!dati.items.length && <tr><td colSpan={5} className="px-3 py-8 text-center text-slate-400">Nessun contatto</td></tr>}
            {dati.items.map((c) => (
              <tr key={c.id} className="border-b hover:bg-slate-50 cursor-pointer" onClick={() => nav(`/crm/contatti/${c.id}`)} data-testid={`crm-contatto-riga-${c.id}`}>
                <td className="px-3 py-2"><Cella>{c.nome}</Cella></td>
                <td className="px-3 py-2"><Cella>{c.telefoni?.map(fmtTelefono).join(", ") || "—"}</Cella></td>
                <td className="px-3 py-2"><Cella>{c.email?.join(", ") || "—"}</Cella></td>
                <td className="px-3 py-2"><ContatoreContatto conteggi={c.conteggi} /></td>
                <td className="px-3 py-2"><Cella>{fmtData(c.ultima_attivita)}</Cella></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
